import SessionsRosterPage from '@/components/pages/calendar/sessions/sessions-roster-page';

function SessionsPage() {
  return (
    <div className="h-full w-full">
      <SessionsRosterPage />
    </div>
  );
}

export default SessionsPage;
